var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-page-shell pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"lg12":"","md12":"","sm12":"","xsl2":""}},[_c('ncoc-calendar',{key:_vm.calendarKey})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }